import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers/rootReducer";
import thunk from "redux-thunk";
import userManager from "./helpers/UserManagerHelper";
import { loadUser } from "redux-oidc";

const store = createStore(rootReducer, applyMiddleware(thunk));

loadUser(store, userManager);

export default store;
